import { apiGet, apiPost } from 'helpers/ApiHelper';
import Auth from 'j-toker';
import { showFailure } from 'actions/notificationActions';
import { FETCH_RESIDENTS, POST_INTERNAL_COMMENT } from './actionTypes';

export function getResidents(ticketID) {
  return dispatch => {
    const url = `${Auth.getApiUrl()}/landlords/maintenance_tickets/${ticketID}/residents`;
    return dispatch({
      type: FETCH_RESIDENTS,
      payload: apiGet(url).catch(error => {
        dispatch(showFailure(error));
      }),
    });
  };
}

export function postInternalComment(ticketId, payload) {
  return dispatch => {
    const url = `${Auth.getApiUrl()}/landlords/ticketing/tickets/${ticketId}/internal_comments`;
    return dispatch({
      type: POST_INTERNAL_COMMENT,
      payload: apiPost(url, payload).catch(error => {
        dispatch(showFailure(error));
        throw error;
      }),
    });
  };
}
